
import { useDriver } from "@/contexts/driver";
import { useEffect } from "react";
import { useAffiliate } from "@/contexts/affiliate";
import OnboardingFloatingMenu from "./OnboardingFloatingMenu";

export const defaultTourConfig = {
  showProgress: true,
  allowClose: true,
  overlayOpacity: 0.3,
  allowKeyboardControl: true,
  popoverOffset: 30,
};

export function AffiliateOnboarding() {
  const { isLoading, details  } = useAffiliate();
  const { setIsTourOpen, isTourOpen } = useDriver();

  // Set initial tour state
  useEffect(() => {
    if (!isLoading && details) {
      setIsTourOpen(true);
    }
  }, [isLoading, details, setIsTourOpen]);

  return <OnboardingFloatingMenu isVisible={isTourOpen} />;
}
